import { useState } from 'react';
import PropTypes from 'prop-types';
// Utils
import { cn } from '@repo/zolintra-utils';
// Components
import { Icon } from '../Icon/Icon';
// Assets
import defaultAvatar from '../../../assets/illustrations/default-avatar.webp';
// Styles
import styles from './Avatar.module.css';

export function Avatar({
  src, size, title, className,
}) {
  const [hasBrokenImage, setHasBrokenImage] = useState(false);

  return (
    <div
      className={cn([
        styles.avatar,
        styles[size],
        hasBrokenImage ? styles.default : '',
        className,
      ])}
    >
      <img
        src={src || defaultAvatar}
        alt={title}
        onError={() => setHasBrokenImage(true)}
      />

      {hasBrokenImage ? (
        <Icon icon="user" className={styles['user-icon']} />
      ) : null}
    </div>
  );
}

Avatar.propTypes = {
  src: PropTypes.string,
  title: PropTypes.string.isRequired,
  size: PropTypes.oneOf(['small', 'medium']),
  className: PropTypes.string,
};

Avatar.defaultProps = {
  src: null,
  size: 'medium',
  className: null,
};

export default Avatar;
